import $http from "../axios";

const state = {
  scaleProductsBase: []
};

const getters = {
  scaleProductsBase: state => {
    return state.scaleProductsBase;
  }
};

const actions = {
  getScaleProducts({ commit }) {
    return new Promise((resolve, reject) => {
      $http
        .get(`scale-products`)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_SCALE_PRODUCTS_BASE", res.data.payload.scaleProducts);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  saveScaleProduct(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("save-scale-product", data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  deleteScaleProduct(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("delete-scale-product", data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {
  SET_SCALE_PRODUCTS_BASE(state, scaleProducts) {
    state.scaleProductsBase = scaleProducts;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
